// libraries
import { get } from "@cloudspire/legacy-shared/src/libraries";

const parseCommentData = ({ rawResponseData }) => {
  return {
    reference: get(rawResponseData, "reference"),
    title: get(rawResponseData, "title"),
    customerContent: get(rawResponseData, "content"),
    composition: get(rawResponseData, "composition"),
    averageRate: Number(get(rawResponseData, "averageRate")),
    fairnessRate: Number(get(rawResponseData, "fairnessRate")),
    greetingRate: Number(get(rawResponseData, "greetingRate")),
    qualityRate: Number(get(rawResponseData, "qualityRate")),
    cosinessRate: Number(get(rawResponseData, "cosinessRate")),
    customerName: get(rawResponseData, "customerName"),
    ownerContent: get(rawResponseData, "answerOwner"),
    agentContent: get(rawResponseData, "answerAgent"),
    ownerName: get(rawResponseData, "ownerName"),
    answeredAt: get(rawResponseData, "answered"),
  };
};

export default parseCommentData;
